import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 37"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M9.4.89c-1.188 0-2.15.984-2.15 2.2v2.2H5.1C2.725 5.29.8 7.26.8 9.69v22c0 2.43 1.925 4.4 4.3 4.4h25.8c2.375 0 4.3-1.97 4.3-4.4v-22c0-2.43-1.925-4.4-4.3-4.4h-2.15v-2.2c0-1.216-.963-2.2-2.15-2.2-1.188 0-2.15.984-2.15 2.2v2.2h-12.9v-2.2c0-1.216-.963-2.2-2.15-2.2m0 11c-1.188 0-2.15.984-2.15 2.2 0 1.214.962 2.2 2.15 2.2h17.2c1.187 0 2.15-.986 2.15-2.2 0-1.216-.963-2.2-2.15-2.2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }